import http from '@/api/http';

export async function userStats(token) {
    try {
        const response = await http.get(
            'api/dashboard/statistic/box-user',
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function listSpaces(token) {
    try {
        const response = await http.get(
            'api/dashboard/company/list-all-three-box',
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function listArchivedSpaces(token) {
    try {
        const dataPram = {
            'is_arhive': true
        }
        const response = await http.get(
            'api/dashboard/company/list-all-three-box',
            {
                params: dataPram,
                headers: { 'Authorization': 'Bearer ' + token }
            })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function listDeletedSpaces(token) {
    try {
        const dataPram = {
            'is_deleted': true
        }        
        const response = await http.get(
            'api/dashboard/company/list-all-three-box',
            {
                params: dataPram,
                headers: { 'Authorization': 'Bearer ' + token }
            })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function listProjects(token) {
    try {
        const response = await http.get(
            'api/dashboard/project/list',
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function projectInfo(token, id) {
    try {
        const dataParam = {
            id: id
        }
        const response = await http.get(
            'api/dashboard/project/one-details',
            {
                params: dataParam,
                headers: { 'Authorization': 'Bearer ' + token }
            })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }    
}

export async function projectTeam(token, id) {
    try {
        const dataParam = {
            id: id
        }
        const response = await http.get(
            'api/dashboard/statistic/table-team',
            {
                params: dataParam,
                headers: { 'Authorization': 'Bearer ' + token }
            })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }    
}

export async function listTasks(token, data) {
    try {
        const dataParam = {
            count: data.count,
            page: data.page
        }

        const response = await http.get(
            'api/dashboard/task/list',
            {
                params: dataParam,
                headers: { 'Authorization': 'Bearer ' + token }
            })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function listComments(token, id) {
    try {
        const dataParam = {
            project: id
        }

        const response = await http.get(
            'api/dashboard/comment/list',
            {
                params: dataParam,
                headers: { 'Authorization': 'Bearer ' + token }
            })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function globalSearch(token, query) {
    try {
        const dataParam = {
            text: query
        }

        const response = await http.get(
            'api/filter/search-all',
            {
                params: dataParam,
                headers: { 'Authorization': 'Bearer ' + token }
            })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function getProjectRights(token, projectId) {
  try {
    const dataParam = {
        id: projectId
    }

    const response = await http.get(
        'api/v1/project/template',
        {
            params: dataParam,
            headers: { 'Authorization': 'Bearer ' + token }
        })
    
    return response.data
  } catch (error) {
    console.error('Error fetching project rights:', error);
    return null; // Возвращаем null вместо выбрасывания ошибки
  }
}
